import { useFormContext } from 'react-hook-form';
import { Grid, TextField } from '@mui/material';
import FieldAutocompleteList from 'components/forms/fields/FieldAutocompleteList';
import FieldDatepicker from 'components/forms/fields/FieldDatepicker';
import { genderOptions } from '../../../pages/main/candidates/constants';
import { EmailRegex } from 'core/login/constants';

const CreateForm = () => {
    const {register, control, formState: {errors}} = useFormContext<any>();

    return (
        <Grid container spacing={2} columns={{xs: 1, sm: 2, xl: 4}}>
            <Grid item xs={1}>
                <TextField
                    id='first_name'
                    label='Prénom'
                    {...register('first_name')}
                    autoComplete='off'
                    error={errors?.first_name ? true : false}
                    helperText={errors?.first_name ? errors.first_name.message as string : null}
                />
            </Grid>
            <Grid item xs={1}>
                <TextField
                    id='last_name'
                    label='Nom'
                    {...register('last_name')}
                    autoComplete='off'
                    error={errors?.last_name ? true : false}
                    helperText={errors?.last_name ? errors.last_name.message as string : null}
                />
            </Grid>
            <Grid item xs={1}>
                <TextField
                    required
                    id='email'
                    label="Email"
                    {...register('account.email', { pattern: EmailRegex })}
                    autoComplete='off'
                    error={errors?.account && (errors?.account as any).email ? true : false}
                    helperText={errors?.account && (errors?.account as any).email ? (errors?.account as any).email.message as string : null}
                />
            </Grid>
            <Grid item xs={1}>
                <TextField
                    required
                    id='password'
                    label="Mot de passe de connexion"
                    {...register('account.password')}
                    autoComplete='off'
                    error={errors?.account && (errors?.account as any).password ? true : false}
                    helperText={errors?.account && (errors?.account as any).password ? (errors?.account as any).password.message as string : null}
                />
            </Grid>
            <Grid item xs={1}>
                <TextField
                    required
                    id='phone_number'
                    label="Numéro de téléphone"
                    {...register('phone_number', {pattern: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im})}
                    autoComplete='off'
                    error={errors?.phone_number ? true : false}
                    helperText={errors?.phone_number ? errors.phone_number.message as string : null}
                />
            </Grid>
            <Grid item xs={1}>
                <FieldDatepicker
                    control={control}
                    label='Date de naissance'
                    fieldName='birthdate'
                />
            </Grid>
            <Grid item xs={1}>
                <FieldAutocompleteList
                    control={control}
                    options={genderOptions}
                    fieldName='gender'
                    labelId='gender'
                    label="Sexe"
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    id='address'
                    label='Adresse'
                    {...register('address.address')}
                    autoComplete='off'
                    error={errors?.address && (errors.address as any).address ? true : false}
                    helperText={errors?.address && (errors.address as any).address ? (errors.address as any).address.message : null}
                />
            </Grid>
        </Grid>
    );
};

export { CreateForm };